import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-badge-collection',
  templateUrl: './badge-collection.component.html',
  styleUrls: ['./badge-collection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeCollectionComponent {
    @Input() background: 'white';
    @Input() elevation: 'popover';

    @HostBinding('class')
    get ngClass() {
        const classes = {};

        if (this.elevation) {
            classes[`elevation-${this.elevation}`] = true;
        }

        if (this.background) {
            classes[`background-${this.background}`] = true;
        }

        return classes;
    }
}
